import { defaultsConfig } from "~config/sport/defaults";
import type { SportConfiguration } from "~types/sportConfiguration.ts";
import { footballUiConfig } from "./footballUi";

export const footballConfig: SportConfiguration = {
  ...defaultsConfig,
  uiConfiguration: footballUiConfig,
};
